import { render, staticRenderFns } from "./AddonRuleList.vue?vue&type=template&id=485de6ba&scoped=true&"
import script from "./AddonRuleList.vue?vue&type=script&lang=js&"
export * from "./AddonRuleList.vue?vue&type=script&lang=js&"
import style0 from "./AddonRuleList.vue?vue&type=style&index=0&id=485de6ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485de6ba",
  null
  
)

export default component.exports